import { DsbcApiOptions } from '../_dsapi/DsbcApiOptions';
import { createDsbcApiUrl } from '../createDsbcApiUrl';
import { DsbcApi } from '../createDsbcRequest';
import { BaseRequest, BaseResponse } from '../shared';

interface batchCollectDrawNumRequest extends BaseRequest {
  invId: string; //邀请活动ID
}

export interface batchCollectDrawNumRequestResVO {}

interface getSumCashResponse extends BaseResponse {
  Data: batchCollectDrawNumRequestResVO;
}

/**
 * 领取抽奖次数
 * 邀请进度页面，单个领取抽奖次数
 * */
export async function batchCollectDrawNum(request: batchCollectDrawNumRequest, options?: DsbcApiOptions) {
  const url = await createDsbcApiUrl('/inv/batchCollectDrawNum');
  return DsbcApi.fetch<getSumCashResponse>(url, request, true, options);
}
